import { Pages as PagesQuery, PAGES_QUERY } from "#app/queries/pages.ts"
import { CmsSection } from "#app/components/cms-section.tsx"
import { Route } from "./+types/$slug"
import { BASE_URL, COMPANY_NAME } from "#app/utils/constants.ts"
import { getSeoMeta } from "#app/utils/seo/getSeoMeta.ts"


export const meta: Route.MetaFunction = ({ data }) => {
    const title = data?.page?.seo?.metaTitle || COMPANY_NAME
	const description =
		data?.page?.seo?.metaDescription ||
		`${COMPANY_NAME} residential page`
    const url = BASE_URL + '/pages/' + data?.page?.slug?.current
    return getSeoMeta({
        title,
        description,
        url,
    })
}

export const loader = async ({ request, params }: Route.LoaderArgs) => {
    const { client } = await import('#app/utils/sanity-client.ts');
    const query = PAGES_QUERY.query
    const page = await client.fetch<PagesQuery>(query, params)

    if (!page) {
        throw new Response('Not found', { status: 404 })
    }
    return {
        page
    }
}


export default function Pages({loaderData}: Route.ComponentProps) {
    const {page} = loaderData
    return (
        <main>
            {page?.sections?.map((section) => (<CmsSection key={section._key} data={section} />))}
        </main>
    )
}